import { useRef, useCallback } from 'react';
import Webcam from 'react-webcam';
import { useHistory } from 'react-router';
// Stores
import testResultStore from '../../stores/TestResultStore';
import translationsStore from '../../stores/TranslationsStore';
// Components
import { BackButton } from 'src/components/BackButton';
import './TestPhoto.scss';
import { TEST_PHOTO_PAGE_BUTTON, TEST_PHOTO_PAGE_TITLE } from 'src/constants/translationKeys';

const TestPhoto = () => {

    const webcamRef = useRef<any>(null);
    const videoConstraints = {facingMode: 'environment'};
    const history = useHistory();
    const translations = translationsStore.translations;

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
            if (testResultStore.testResult) {
                testResultStore.testResult.resultPhoto = imageSrc;
                history.goBack();
            }
        }
      }, [webcamRef, history]);

    return (
        <section className={`test-photo-page content`}>
            <div className="container">
            <BackButton />
            <p className="test-photo-page__description">
                {translations[TEST_PHOTO_PAGE_TITLE]}
            </p>
            <div className={"test-photo-page__camera"}>
                <div className="test-photo-page__overlay"/>
                <Webcam
                    videoConstraints={videoConstraints}
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                />
            </div>
            <div className="component-footer">
    
                <button onClick={capture} className="button filled-button photo-button">
                    {translations[TEST_PHOTO_PAGE_BUTTON]}
                </button>
            </div>
            </div>
        </section>
    )
}

export default TestPhoto;